export const UPLOAD_FILE_FIELD = 'edit_listing_page__upload_file';
export const DELETE_FILE_FIELD = 'edit_listing_page__delete_file';
